module.exports = __webpack_public_path__ + "img/9_35.71d095c4.png";